'use client'

import { createContext, useContext, useState, ReactNode } from 'react'

interface AuthContextType {
  authModalOpen: boolean
  setAuthModalOpen: (open: boolean) => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function AuthProvider({ children }: { children: ReactNode }) {
  const [authModalOpen, setAuthModalOpen] = useState(false)

  return (
    <AuthContext.Provider value={{ authModalOpen, setAuthModalOpen }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuthModal() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuthModal must be used within an AuthProvider')
  }
  return context
}
